import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ROLE_IDS } from '@/domain/constants/roles';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { AppLayout } from '@/shared/components/Layout/AppLayout';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { PanelDetailPage } from '@/pages/PanelDetailPage';
import { HistoryDataPage } from '@/pages/HistoryDataPage';
import { RealtimeDataPage } from '@/pages/RealtimeDataPage';
import { ControlSettingsPage } from '@/pages/ControlSettingsPage';
import { InventoryPage } from '@/pages/InventoryPage';
import { PurchaseOrderListPage } from '@/pages/PurchaseOrderListPage';

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* ログインページ */}
      <Route path="/login" element={<LoginPage />} />

      {/* 認証が必要なルート */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/panels/:panelId" element={<PanelDetailPage />} />
          <Route path="/history-data" element={<HistoryDataPage />} />
          <Route path="/realtime-data" element={<RealtimeDataPage />} />
          <Route path="/inventory" element={<InventoryPage />} />
          <Route path="/purchase-orders" element={<PurchaseOrderListPage />} />
        </Route>
      </Route>

      {/* MCMユーザーと開発ユーザーのみアクセス可能なルート */}
      <Route element={<ProtectedRoute allowedRoleIds={[ROLE_IDS.DEV_USER, ROLE_IDS.MCM_USER]} />}>
        <Route element={<AppLayout />}>
          <Route path="/settings" element={<ControlSettingsPage />} />
        </Route>
      </Route>

      {/* デフォルトリダイレクト */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* 404ページ */}
      <Route path="*" element={<div>ページが見つかりません</div>} />
    </Routes>
  );
};